import {useTelegram} from "./Telegram";

export const post = (url, data = {}, type = "json") => {
    const {code, device_id, state} = Object.fromEntries(new URLSearchParams(window.location.search));

    data.tariff_id = data.tariff_id || localStorage.getItem("tariff_id");
    data.state = localStorage.getItem("vk_state");
    data.code_verifier = localStorage.getItem("vk_code_verifier");
    data.user_id = localStorage.getItem("user_id");

    if (code) {
        window.history.replaceState({}, "", window.location.pathname);
        if (state === data.state) {
            data.code = code;
            data.device_id = device_id;
        }
    }

    if (url === "https://ipresent.ru/api/vk-get-main-data/") {
        data.visit_id = localStorage.getItem("visit_id") || (visit_id => localStorage.setItem("visit_id", visit_id) || visit_id)(crypto.randomUUID());
        data.referrer = document.referrer;
        data.location = document.location.href;
        data.userAgent = navigator.userAgent;
        data.platform = navigator.platform;
        data.width = window.innerWidth;
        data.height = window.innerHeight;
    }


    return fetch(url, {
        method: "post",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(data)
    }).then(async res => {
        const data = (type === "blob" && await res.blob()) || await res.json();

        data?.vk?.user_id && localStorage.setItem("user_id", data.vk.user_id);

        return data
    })
}

export const usePostWithTelegram = () => {
    const {webApp} = useTelegram();

    const post = (url, data = {}) => fetch(url, {
        method: "post",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({...data, initData: webApp?.initData})
    }).then(res => res.json())

    return {post}
}

export const replaceInObject = (obj, str1, str2) => {
    if (typeof obj === "string") {
        return obj.replaceAll(str1, str2);
    }

    if (Array.isArray(obj)) {
        return obj.map(item => replaceInObject(item, str1, str2));
    }

    if (obj !== null && typeof obj === "object") {
        const result = {};
        for (const key in obj) {
            result[key] = replaceInObject(obj[key], str1, str2);
        }
        return result;
    }

    return obj;
}
